<button
  [type]="type"
  [ngClass]="className"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
>
  <ng-container *ngIf="loading; else defaultBtn">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{ loadingLabel }}
  </ng-container>

  <ng-template #defaultBtn>
    <i *ngIf="icon" [class]="icon" aria-hidden="true"></i>
    {{ label }}
  </ng-template>
</button>
